const colors = {
  black: '#000',
  textBlack: '#131313',
  blue: '#4BACF7',
  blueGray: '#737380',
  deepBlue: '#007AFF',
  gray: '#8E9099',
  gray2: '#9E9E9E',
  grayDark: '#404040',
  grayLight: '#e6e8f2',
  grayLighter: '#fcfcfc',
  grayBg: '#f7f7fC',
  green: '#BEEA06',
  greenLight: '#E5F06E',
  main: '#1f1f41',
  white: '#fff',
  placeholderColor: '#8F9BB3',
  pink: '#FEF1F4',
  pink2: '#F6D1CC',
  pink3: '#EB8B80',
  red: '#FA7268',
  yellow: '#FAEDAF',
  yellow2: '#FFEB00',
  yellow3: '#ccbc00',
  purple: '#b656f3',
  grayLightBg: '#F9F5F5',
  greenSuccess: '#4BB543',
  greenMain: '#0be094',
  gray3: '#e8ecf3',
}

export const gradients = {
  mainGradient: 'linear-gradient(180deg, #C34FFC 0%, #FF66CB 100%)',
}

export default colors
